<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<input
  type="text"
  [id]="'inputElement-' + id"
  #inputElement
  [class.empty]="isEmpty()"
  autocomplete="off"
  (input)="inputChanged($event)"
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  inputmode="decimal"
  (keydown)="onKeyDown($event)"
  [placeholder]="placeholder ? placeholder : ''"
  data-zid="number-input"
/>

<label [for]="'inputElement-' + id">{{ label }}</label>
